import Vue from "vue";
// firebase must be loaded before router
import "@/plugins/firebase";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import VueCompositionAPI from "@vue/composition-api";
import { formatDate, formatMoney } from "./utils/utils";
import IdleVue from "idle-vue";
import config from "@/configs";

// We use the value if is needed, because this plugin set some properties to all components
// and add a store to see the isIdle flag
if (config?.settings?.idleTime) {
  const eventsHub = new Vue();
  Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: config?.settings?.idleTime,
    startAtIdle: false,
  });
}

Vue.use(VueCompositionAPI);
Vue.config.productionTip = false;

// Custom directives, use ie <div v-date="someDate" />
Vue.directive("money", (el, binding) => {
  el.innerText = formatMoney(binding.value);
});

Vue.directive("date", (el, binding) => {
  const formattedDate = formatDate(binding.value);
  el.innerText = formattedDate;
});

Vue.directive("dash", (el, binding) => {
  el.innerText = binding.value ? binding.value : "—";
});

const scriptLoader = {
  loaded: [],
  load(source: string) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (this.loaded.indexOf(source) !== -1) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.loaded.push(source);

    if (document) {
      const script = document.createElement("script");
      script.setAttribute("src", source);
      document.head.appendChild(script);
    }
  },
};

Vue.use({
  install() {
    Vue.prototype.$scriptLoader = scriptLoader;
    // Vue.prototype.$api = axios;
    // Vue.prototype.$db = db
    // Vue.prototype.$storage = storage
    // Vue.prototype.$firebase = firebase
  },
});

// eslint-disable-next-line
let VueApp: any;
const createApp = () => {
  VueApp = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
  /**
   * Load any 3rd party scripts required here
   */
  VueApp.$scriptLoader.load("https://js.stripe.com/v3/");
};

const auth = getAuth();
onAuthStateChanged(auth, (user) => {
  if (!VueApp) {
    createApp();

    if (user) {
      if (process.env.NODE_ENV === "development") console.log(user);

      store.dispatch("auth/afterLogin");
    }
  }

  //app.config.globalProperties.$user = user
});
